<template>
  <div>
    <header class="form-title">
        充值记录
         <!-- <Form inline :label-width="80">
              <FormItem label="店铺" v-if="isCustomerSharing==1">
                <Select v-model="searchshopName" filterable style="width: 200px">
                  <Option
                          :value="k.id"
                          v-for="(k,v) in shopList"
                          :key="v">{{k.name}}</Option>
                </Select>
              </FormItem>
          </Form>-->
    </header>
    <Table stripe :columns="columns" :data="lists" :loading="loadingTable"></Table>
    <!-- 分页 -->
    <div class="pageTotal">
      <Page :total="page.pageTotal" :page-size="page.rows" show-total @on-change="onChangePage" />
    </div>
  </div>
</template>
<script>
import { Exp } from "@/util/Exp";
export default {
  name: "customerAnalysis",
  data() {
    return {

      loadingTable: false,
      columns: [
        { title: "客户", key: "customerName", align: "center" },
        { title: "店铺名称", key: "shopName", align: "center" },
        { title: "制单人", key: "creatorName", align: "center" },
        { title: "充值金额", key: "money", align: "center" },
        { title: "赠送", key: "gmoney", align: "center" },
        { title: "充值类型", key: "orderType", align: "center" },
        { title: "支付方式", key: "payType", align: "center" },
        { title: "充值时间", key: "time", align: "center" },
        { title: "订单编号", key: "orderCode", align: "center" }
      ],
      lists: [],
      page: {
        pageTotal: 0,
        rows: 10
      },
      formData: {
        page: 1,
        rows: 10,
        cid: JSON.parse(localStorage.getItem("shop")).cid,
        customerid: ""
      },
      isCustomerSharing:0, //客户共享是否开启 0关 1开
      shopList: [],//店铺列表
      searchshopName: ''
    };
  },
  created() {

    this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
    this.formData.customerid = this.$route.query.cusId;
    this.getMemberLogWater();
    this.getShopList()
  },

  watch: {
   /* 'searchshopName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.formData.sid = newVal
        this.getMemberLogWater();
      }
    },*/
  },



  methods: {
    //店铺列表
    getShopList() {
      var data = {
        cid: JSON.parse(localStorage.getItem('shop')).cid,
        page: 1,
        rows: 1000,
        isFilter: 1
      };
      this.$Api.getShopList(data).then(res => {
        this.shopList = res.data;
        this.searchshopName = JSON.parse(localStorage.getItem('shop')).id
      });
    },
    // 获取充值记录
    getMemberLogWater() {
      this.loadingTable = true;
      this.$Api
        .getMemberLogWater(this.formData)
        .then(res => {
          res.data.forEach(val => {
            val.orderType = "会员卡充值";
          });
          this.lists = res.data;
          this.page.pageTotal = res.count;
          this.loadingTable = false;
        })
        .catch(err => {
          this.loadingTable = false;
        });
    },
    onChangePage(num) {
      this.formData.page = num;
      this.getMemberLogWater();
    }
  }
};
</script>
<style lang="scss" scoped>
.form-title {
  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
</style>